
<script lang="ts">
  import AutomationItem from './AutomationItem.svelte';
  import Portal from '../other/Portal.svelte';
  import DefaultPopup from '../popups/DefaultPopup.svelte';
  import DefaultButton from '../buttons/DefaultButton.svelte';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  let loading: boolean = false;
  let popupActive: boolean = false;

  export let user;
  export let microsoftSharepointTenantId;

  const handleClick = () => {
    if (!microsoftSharepointTenantId) {
      popupActive = true;
    } else {
      dispatch('open');
    }
  };

  const grantConsent = () => {
    const consentUrl = `https://login.microsoftonline.com/common/adminconsent?client_id=7b0ca8a3-0bc1-4fce-885d-8428d3b98aac&redirect_uri=https://api.qix.cloud/microsoftRedirectAdminConsent&state=${user.id}`;
    window.open(consentUrl, '_blank');
    popupActive = false;
  };

  $: microsoftSharepointEnabled = microsoftSharepointTenantId !== null && microsoftSharepointTenantId !== undefined && microsoftSharepointTenantId !== '';

</script>

<AutomationItem bind:enabled={microsoftSharepointEnabled} {loading} name="SharePoint" img="/sharepoint.svg" on:click={() => handleClick()} />
<Portal>
  <DefaultPopup bind:active={popupActive} zIndex="{1102}">
    <div class="sharepoint-automation-popup">
      <h2 class="sharepoint-automation-popup__title">Microsoft SharePoint Setup</h2>
      <img class="sharepoint-automation-popup__img" src="/sharepoint.svg" alt="">
      <span class="sharepoint-automation-popup__subtitle">Grant consent to enable SharePoint integration</span>

      <div class="sharepoint-automation-popup__info">
        <p>Click the button below to grant admin consent for SharePoint access.</p>
      </div>

      <div class="sharepoint-automation-popup__consent">
        <DefaultButton
          text="Grant Consent for SharePoint"
          type="button"
          on:click={grantConsent}
        />
      </div>
    </div>
  </DefaultPopup>
</Portal>

<style lang="scss" scoped>
  .sharepoint-automation-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90vw;
    max-width: 400px;
    padding: 10px 30px 30px;

    &__title {
      margin: 0 auto 10px 0;
      font-weight: 400;
      font-size: 1.2rem;
    }

    &__img {
      width: 90%;
      max-width: 60px;
      margin-bottom: 20px;
      margin-top: 20px;
    }

    &__subtitle {
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
    }

    &__info {
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
      padding: 10px;
      background-color: #f5f5f5;
      border-radius: 5px;

      p {
        margin: 0;
        font-size: 0.9rem;
        color: #666;
      }
    }

    &__consent {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
</style>
